export const TUTORLOGIN = 'TUTORLOGIN';
export const TUTORSIGNUP = 'TUTORSIGNUP';
export const TUTORPASSWORDFORGOT = 'TUTORPASSWORDFORGOT';
export const STEP_TUTORPROFILESINGUP = 'TUTORPROFILESINGUP';
export const STEP_SCHOOLPROFILESIGNUP = 'SCHOOLPROFILESIGNUP';
export const STEP_PASSWORDSIGNUP = 'PASSWORDSIGNUP';